import { put, takeEvery } from "redux-saga/effects";
import {
  FETCH_EXPIRYRETURNDETAILS_INIT_ACTION,
  FETCH_EXPIRYRETURNDETAILS_SUCCESS_ACTION,
  FETCH_EXPIRYRETURNDETAILS_FAIL_ACTION,
  FETCH_EXPIRYRETURNSEARCH_INIT_ACTION,
  FETCH_EXPIRYRETURNSEARCH_FAIL_ACTION,
  FETCH_EXPIRYRETURNSEARCH_SUCCESS_ACTION,
  FETCH_EXPIRYRETURNVIEW_INIT_ACTION,
  FETCH_EXPIRYRETURNVIEW_SUCCESS_ACTION,
  FETCH_EXPIRYRETURNVIEW_FAIL_ACTION,
  FILTER_BY_EXPIRYRETURN_STATUS_INIT_ACTION,
  FILTER_BY_EXPIRYRETURN_STATUS_SUCCESS_ACTION,
  FILTER_BY_EXPIRYRETURN_STATUS_FAIL_ACTION,
} from "./action";
import { appConfig } from "../../config";

function* fetchExpiryReturn(value) {
  const token = localStorage.getItem("token");
  let pageno = value.value === undefined ? 1 : value.value;

  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder?orderType=expiryReturn&&limit=10&page=${pageno}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );

    if (!res.ok) throw res;
    const resJSON = yield res.json();

    yield put({
      type: FETCH_EXPIRYRETURNDETAILS_SUCCESS_ACTION,
      payload: resJSON
    });
  } catch (err) {
    yield put({ type: FETCH_EXPIRYRETURNDETAILS_FAIL_ACTION, error: err });
  }
}

function* fetchSearchExpiryReturn(value) {
  const token = localStorage.getItem("token");
  const searchVal = value.value.ExpiryReturns || "";
  const page = value.value.Spage || 1;

  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder?orderType=expiryReturn&limit=10&page=${page}&search=${searchVal}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!res.ok) throw res;

    const resJSON = yield res.json();

    yield put({
      type: FETCH_EXPIRYRETURNSEARCH_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    yield put({
      type: FETCH_EXPIRYRETURNSEARCH_FAIL_ACTION,
      error: err,
    });
  }
}


function* fetchExpiryReturnView(value) {
  const token = localStorage.getItem("token");

  try {
    const res = yield fetch(
      `${appConfig.ip}/orderDetails?orderId=${value.value.item.id}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );

    if (!res.ok) throw res;
    const resJSON = yield res.json();

    yield put({
      type: FETCH_EXPIRYRETURNVIEW_SUCCESS_ACTION,
      payload: resJSON
    });
  } catch (err) {
    yield put({ type: FETCH_EXPIRYRETURNVIEW_FAIL_ACTION, error: err });
  }
}

function* FilterSearchExpiryUser(value) {
  const token = localStorage.getItem("token");

  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder?orderType=expiryReturn&&limit=10&page=${value.value.page}&&status=${value.value.value}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );

    if (!res.ok) throw res;
    const resJSON = yield res.json();

    yield put({
      type: FILTER_BY_EXPIRYRETURN_STATUS_SUCCESS_ACTION,
      payload: resJSON
    });
  } catch (err) {
    yield put({
      type: FILTER_BY_EXPIRYRETURN_STATUS_FAIL_ACTION,
      error: err
    });
  }
}

export function* ExpiryReturnsActionWatcher() {
  yield takeEvery(FETCH_EXPIRYRETURNDETAILS_INIT_ACTION, fetchExpiryReturn);
  yield takeEvery(
    FETCH_EXPIRYRETURNSEARCH_INIT_ACTION,
    fetchSearchExpiryReturn
  );
  yield takeEvery(
    FETCH_EXPIRYRETURNVIEW_INIT_ACTION,
    fetchExpiryReturnView
  );
  yield takeEvery(
    FILTER_BY_EXPIRYRETURN_STATUS_INIT_ACTION,
    FilterSearchExpiryUser
  );
}
